import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import schutletable from '../assets/images/The-Schulte-Table.jpg'
import memoryGameIcon from '../assets/images/memory.png'
import UserSelector from '../components/UserSelector'
import Activity from '../components/Activity'

const Activities = () => {
  let games = [
    {
      id: 10,
      title: 'Memory game',
      text: 'Find matching pairs',
      link: 'memorygame',
      image: memoryGameIcon,
      isFree: true,
    },
    {
      id: 16,
      title: 'Schutle',
      text: 'Focus and find items in order',
      link: 'schutle',
      image: schutletable,
      isFree: false,
    },
  ]

  return (
    <Container fluid>
      <div className='dashboard-heading'>
        <div className='content-container'>
          <h2>Games</h2>
          <p>Play games using your brain, literally!</p>
        </div>
        <Activity />
      </div>
      <UserSelector />
      <Row>
        {games.map((d, i) => {
          return (
            <Col key={i} md={6} xl={4} xxl={3}>
              <div className='dashboard-cards p-3 d-flex align-items-center gap-4'>
                <img src={d.image} alt='icon' height={100} width={100} />
                <div className='w-100'>
                  <h4 className='m-0 mb-1'>{d.title}</h4>
                  <p>{d.text}</p>
                  <div className='d-flex flex-wrap gap-2'>
                    <div className='btn-container flex-fill'>
                      <NavLink to={`/games/${d.link}`}>
                        <button className='common-btn w-100 p-2'>Play</button>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </Container>
  )
}

export default Activities
